import { MAP_ZOOM_LEVEL } from '../../../../../util/mapCreator/mapUtils';

export const HEADER_HEIGHT = 25;
export const BOX_WIDTH = 26;
export const BOX_HEIGHT = 20;
export const FONT_COLOR = '#232323';
export const TRAPEZE_SIZE = 10;
export const TRAPEZE_MARGIN = 5;
export const boxColors = {
    green: '#01AF69',
    amber: '#FFB74D',
    yellow: '#FEB03A',
    red: '#DC4A5D',
    burgundy: '#A32626',
    blue: '#3C78D8',
    graphite: '#232323',
};
export const statusColors = {
    green: {
        color: '#ffffff',
        background: '#c9e7d4',
        line: '#2e6441',
    },
    orange: {
        color: '#FFFFFF',
        background: '#F26B28',
        line: '#f8590a',
    },
    amber: {
        color: '#ffffff',
        background: '#ffd966',
        line: '#fac018',
    },
    red: {
        color: '#ffffff',
        background: '#f4c3c6',
        line: '#b43238',
    },
    blue: {
        color: '#ffffff',
        background: '#2180f7',
        line: '#0672fa',
    },
    white: {
        color: '#000000',
        background: '#ffffff',
        line: '#000000',
    },
    purple: {
        color: '#ffffff',
        background: '#A883B9',
        line: '#963ebe',
    },
    lightBlue: {
        color: '#ffffff',
        background: '#83AFB9',
        line: '#56a5b7',
    },
    grey: {
        color: '#ffffff',
        background: '#404040',
        line: '#000000',
    },
    graphite: {
        color: '#ffffff',
        background: '#232323',
        line: '#000000',
    },
};

export const getZoomModifier = (level) => {
    switch (level) {
        case MAP_ZOOM_LEVEL.BIG:
            return 1.3;

        case MAP_ZOOM_LEVEL.FULL:
        default:
            return 1;
    }
};

export const getFontSize = (level) => {
    switch (level) {
        case MAP_ZOOM_LEVEL.MEDIUM:
            return 23;

        case MAP_ZOOM_LEVEL.BIG:
            return 10;

        case MAP_ZOOM_LEVEL.FULL:
        default:
            return 8;
    }
};

export const DEFAULT_TOOLTIP_STATE = {
    visible: false,
    isLobby: false,
    x: 0,
    y: 0,
    text: '',
    fontSize: 14,
    align: 'center',
};
